import React, { HTMLAttributes } from 'react'
import injectSheet from 'react-jss'
import cx from 'classnames'
import { Classes } from 'jss'
import { sheet } from './sheet'

export type Tone = 'blue' | 'green' | 'purple' | 'red'

export interface FeatureCardProps {
  classes: Classes
  icon: React.ReactNode
  title: string
  text: string
  tone?: Tone
  className?: string
}

const toneClass = (classes: Classes, tone?: Tone) => {
  if (!tone) return undefined
  return {
    orange: classes.toneOrange,
    blue: classes.toneBlue,
    green: classes.toneGreen,
    purple: classes.tonePurple,
    red: classes.toneRed
  }[tone]
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  classes,
  icon,
  title,
  text,
  tone = 'blue',
  className
}) => {
  return (
    <article className={cx(classes.card, className)}>
      <div className={cx(classes.badge, toneClass(classes, tone))}>
        {/* note: SVG takes color from currentColor */}
        {icon}
      </div>

      <div className={classes.content}>
        <h5 className={classes.title}>{title}</h5>
        <p className={classes.text}>{text}</p>
      </div>
    </article>
  )
}

export default injectSheet(sheet)(FeatureCard)
